<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style="color: grey">
        <!--begin::Portlet-->
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head no-border-radius">
                <div class="kt-portlet__head-label">
                </div>
                <div class="kt-portlet__head-toolbar">
                    <app-button type="secondary" @handleClick="back">
                        <i class="glyphicons glyphicons-arrow-left"></i>{{ $t('AppImplementForm.back') }}
                    </app-button>
                </div>
            </div>
            <div class="kt-form shadow-lg pl-3 pr-3 bg-white my-4">
                <div v-if="loading" class="loading">
                    <ProgressSpinner style="height: 10vh"
                                     class="mt-5 mb-5 d-flex align-items-center justify-content-center"/>
                </div>
                <form v-else @submit.prevent>
                    <div class="kt-portlet__body">
                        <p class="m-0 text-right">Organização: {{ organizationName }}</p>
                        <div class="form-group text-center mt-3">
                            <h3>{{ isEditing ? $t('AppImplementForm.Editando') : $t('AppImplementForm.Novo implemento') }}</h3>
                        </div>

                        <div class="form-group row mx-2">
                            <span class="p-float-label" style="width: 100%">
                                <InputText id="identification" type="text" v-model.trim="formImplementIdentification"
                                           maxlength="24" style="width: 100%" @input="validateIdentification($event)"
                                           :class="{'p-invalid': (submitted && !formImplementIdentification) ||
                                           (submitted && nameInUse)}"/>
                                <label for="identification">{{ $t('AppImplementForm.Identificação') }}</label>
                            </span>
                            <small v-if="submitted && !formImplementIdentification" class="pl-1 pt-1"
                                   style="color: #f44336">
                                {{ $t('AppImplementForm.Campo obrigatório') }}
                            </small>
                        </div>
                        <div class="form-group row mx-2">
                            <span class="p-float-label" style="width: 100%">
                                <InputText id="chassis" type="text" v-model.trim="formImplementChassis"
                                           maxlength="24" style="width: 100%"
                                           :class="{'p-invalid': (submitted && !formImplementIdentification) ||
                                           (submitted && chassisInUse)}"/>
                                <label for="chassis">{{ $t('AppImplementForm.Chassis') }}</label>
                            </span>
                        </div>
                        <div class="form-group row mx-2 mt-3" v-if="!otherModel">
                            <span class="p-float-label" style="width: 100%">
                                <Dropdown v-model="formImplementManufacturer" :dataKey="'id'" :filter="true"
                                          :options="implementManufacturers" optionLabel="name" style="width: 100%"
                                          @change="getImplementModels(false)" id="dropdownManufacturer"
                                          :class="{'p-invalid': submitted && !formImplementManufacturer}"/>
                                <label for="dropdownManufacturer">{{ $t('AppImplementForm.Fabricante') }}</label>
                            </span>
                            <small v-if="submitted && !formImplementManufacturer" class="pl-1 pt-1"
                                   style="color: #f44336">
                                {{ $t('AppImplementForm.Campo obrigatório') }}
                            </small>
                        </div>
                        <div class="form-group row mx-2 mt-3" v-if="otherModel">
                            <span class="p-float-label" style="width: 100%">
                                <InputText id="otherManufacturer" type="text" v-model.trim="formOtherManufacturer"
                                           style="width: 100%"
                                           :class="{'p-invalid': submitted && !formOtherManufacturer}"/>
                                <label for="otherManufacturer">{{ $t('AppImplementForm.Nome do fabricante') }}</label>
                            </span>
                            <small v-if="submitted && !formOtherManufacturer" class="pl-1 pt-1"
                                   style="color: #f44336">
                                {{ $t('AppImplementForm.Campo obrigatório') }}
                            </small>
                        </div>
                        <div class="form-group row mx-2 mt-3" v-if="!otherModel">
                            <span class="p-float-label" style="width: 100%">
                                <Dropdown :disabled="!formImplementManufacturer" :filter="true"
                                          optionLabel="name" v-model="formImplementModel" :options="implementModels"
                                          id="dropdownModel" :dataKey="'id'" style="width: 100%"
                                          @change="getImplementInfo()"
                                          :class="{'p-invalid': measurementsSubmitted && !formImplementModel}"/>
                                <label for="dropdownModel">{{ $t('AppImplementForm.Modelo') }}</label>
                            </span>
                            <small v-if="measurementsSubmitted && !formImplementModel" class="pl-1 pt-1"
                                   style="color: #f44336">
                                {{ $t('AppImplementForm.Campo obrigatório') }}
                            </small>
                        </div>
                        <div class="form-group row mx-2 mt-3" v-if="otherModel">
                            <span class="p-float-label" style="width: 100%">
                                <InputText id="otherModel" type="text" v-model.trim="formOtherModel"
                                           style="width: 100%" :class="{'p-invalid': submitted && !formOtherModel}"/>
                                <label for="otherModel">{{ $t('AppImplementForm.Nome do modelo') }}</label>
                            </span>
                            <small v-if="submitted && !formOtherModel" class="pl-1 pt-1" style="color: #f44336">
                                {{ $t('AppImplementForm.Campo obrigatório') }}
                            </small>
                        </div>
                        <div class="form-group row mx-2 mt-3">
                            <span class="p-float-label" style="width: 100%">
                                <Dropdown v-model="formImplementType" :dataKey="'value'" :filter="true"
                                          :options="implementTypes" optionLabel="text" style="width: 100%"
                                          id="implementType" :disabled="!otherModel"
                                          @change="handleImplementType()"
                                          :class="{'p-invalid': submitted && otherModel && !formImplementType}"/>
                                <label for="implementType">{{ $t('AppImplementForm.Tipo do implemento') }}</label>
                            </span>
                            <small v-if="submitted && otherModel && !formImplementType" class="pl-1 pt-1"
                                   style="color: #f44336">
                                {{ $t('AppImplementForm.Campo obrigatório') }}
                            </small>
                        </div>
                        <div class="form-group row mx-2 mt-3">
                            <div class="d-flex flex-column align-content-end">
                                <div class="mx-2">
                                    {{ $t('AppImplementForm.Não encontrou o modelo na lista?') }}
                                </div>
                                <div class="row mx-2 mt-2 flex-nowrap">
                                    <Checkbox id="isOtherModel" v-model="otherModel" :binary="true"
                                              @click="handleCheckbox"/>
                                    <label for="isOtherModel" class="pl-2" style="cursor: pointer">
                                        {{ $t('AppImplementForm.Clique aqui para adicionar um novo modelo') }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <hr class="dashed row mt-1"/>
                        <div v-if="!formImplementModel && !selectedImplement" class="text-center mt-3">
                            {{ $t('AppImplementForm.Selecione um modelo para visualizar suas medidas') }}
                        </div>
                        <div v-else-if="loadingMeasurements">
                            <ProgressSpinner style="height: 10vh"
                                             class="mt-5 mb-5 d-flex align-items-center justify-content-center"/>
                        </div>
                        <div v-else class="d-flex flex-column">
                            <div class="text-right" v-if="!otherModel">
                                <small v-if="!selectedImplement.descriptor" style="color: #f44336">
                                    {{ $t('AppImplementForm.*O modelo não possui medidas padrão cadastradas, Favor preencher os campos abaixo') }}
                                </small>
                                <small v-else style="color: #e19900">
                                    {{ $t('AppImplementForm.Exibindo as medidas padrão do modelo, Modifique conforme necessário') }}
                                </small>
                            </div>
                            <div class="form-group row mx-2 mt-5">
                                <span class="p-float-label" style="width: 100%">
                                    <Dropdown v-model="formConnectorTypeSelected" :dataKey="'id'" :filter="true"
                                              :options="connectorTypes" optionLabel="name" style="width: 100%"
                                              id="dropdownConnector" :disabled="isPlatform"
                                              :class="{'p-invalid': measurementsSubmitted && !formConnectorTypeSelected}"/>
                                    <label for="dropdownConnector">{{ $t('AppImplementForm.Engate') }}</label>
                                </span>
                                <small v-if="measurementsSubmitted && !formConnectorTypeSelected" class="pl-1 pt-1"
                                       style="color: #f44336">
                                    {{ $t('AppImplementForm.Campo obrigatório') }}
                                </small>
                            </div>
                            <div class="form-group row mx-2 mt-3">
                                <span class="p-float-label" style="width: 100%">
                                    <Dropdown v-model="formCulturePracticeSelected" :dataKey="'value'" :filter="true"
                                              :options="culturePracticeList" optionLabel="text" style="width: 100%"
                                              id="dropdownCulturePractice" @change="handleCulturePractice()"
                                              :class="{'p-invalid': measurementsSubmitted && !formCulturePracticeSelected}"/>
                                    <label for="dropdownCulturePractice">{{ $t('AppImplementForm.Operação') }}</label>
                                </span>
                                <small v-if="measurementsSubmitted && !formCulturePracticeSelected" class="pl-1 pt-1"
                                       style="color: #f44336">
                                    {{ $t('AppImplementForm.Campo obrigatório') }}
                                </small>
                            </div>
                            <div class="form-group row mx-2 mt-3 mb-5" v-if="hasMonitoringSystem">
                                <span class="p-float-label" style="width: 100%">
                                    <Dropdown v-model="formMonitoringSystem" :dataKey="'id'"
                                              :options="monitoringSystemList" id="dropdownMonitoringSystem"
                                              optionLabel="name" style="width: 100%"
                                              :class="{'p-invalid': measurementsSubmitted && !formMonitoringSystem}"/>
                                    <label for="dropdownMonitoringSystem">{{ $t('AppImplementForm.Sistema de monitoramento') }}</label>
                                </span>
                                <small v-if="measurementsSubmitted && !formMonitoringSystem" class="pl-1 pt-1"
                                       style="color: #f44336">
                                    {{ $t('AppImplementForm.Campo obrigatório') }}
                                </small>
                            </div>
                            <div v-if="isPlatform">
                                <div class="form-group mx-2 mt-2 mt-md-5 row justify-content-between px-0">
                                    <div class="col-12 col-md-4 text-center">
                                        <div>
                                            {{ $t('AppImplementForm.Distância da Plataforma') }}
                                            <i class="pi pi-question-circle"
                                               v-tooltip.top="'Distância do Conector da Plataforma até o Ponto de Trabalho'"></i>
                                        </div>
                                        <img class="image" src="@/assets/images/implement/platform-erp_x.png">
                                    </div>
                                    <div class="col-12 col-md-7 d-flex flex-column text-left">
                                        <div class="d-flex flex-column mt-3">
                                            <label class="mb-0">Distância</label>
                                            <InputNumber v-model.number="formMeasurements.function[0].erp[0]"
                                                         suffix=" cm" :min="0" :useGrouping="false"
                                                         placeholder="Digite o valor em centímetros"
                                                         :class="{'p-invalid': fieldNotFilled(formMeasurements.function[0].erp[0])}"/>
                                            <small v-if="fieldNotFilled(formMeasurements.function[0].erp[0])"
                                                   class="pl-1 pt-1" style="color: #f44336">
                                                {{ $t('AppImplementForm.Campo obrigatório') }}
                                            </small>
                                            <small class="text-right mt-1">
                                                {{ showValueInMeters(formMeasurements.function[0].erp[0]) }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group mx-2 mt-2 mt-md-5 row justify-content-between px-0">
                                    <div class="col-12 col-md-4 text-center">
                                        <div>
                                            {{ $t('AppImplementForm.Largura de Trabalho') }}
                                            <i class="pi pi-question-circle"
                                               v-tooltip.top="'Comprimento Total do Trabalho'"></i>
                                        </div>
                                        <img class="image" src="@/assets/images/implement/platform-width.png">
                                    </div>
                                    <div class="col-12 col-md-7 d-flex flex-column text-left">
                                        <div class="d-flex flex-column mt-3">
                                            <label class="mb-0">{{ $t('AppImplementForm.Largura') }}</label>
                                            <InputNumber v-model.number="formMeasurements.function[0].width"
                                                         suffix=" cm" :useGrouping="false" :min="0"
                                                         placeholder="Digite o valor em centímetros"
                                                         :class="{'p-invalid': fieldNotFilled(formMeasurements.function[0].width)}"/>
                                            <small v-if="fieldNotFilled(formMeasurements.function[0].width)"
                                                   class="pl-1 pt-1" style="color: #f44336">
                                                {{ $t('AppImplementForm.Campo obrigatório') }}
                                            </small>
                                            <small class="text-right mt-1">
                                                {{ showValueInMeters(formMeasurements.function[0].width) }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="d-flex flex-column">
                                <div class="form-group mx-2 mt-2 mt-md-5 row justify-content-between px-0">
                                    <div class="col-12 col-md-4 text-center">
                                        <div>
                                            {{ $t('AppImplementForm.Centro de Rotação') }}
                                            <i class="pi pi-question-circle"
                                               v-tooltip.top="'Distância em linha do ponto de conexão ao centro de rotação do implemento enquanto na posição de trabalho'"></i>
                                        </div>
                                        <img class="image" src="@/assets/images/implement/implement-crp_x.png">
                                    </div>
                                    <div class="col-12 col-md-7 d-flex flex-column justify-content-between text-left">
                                        <div class="d-flex flex-column">
                                            <label class="mb-0">{{ $t('AppImplementForm.Posição do implemento') }}</label>
                                            <SelectButton v-model="formMeasurements.implement_position"
                                                          :options="implementPositions"
                                                          style="width: 100%" optionLabel="name"/>
                                            <small class="text-right mt-1" style="height: 1rem"/>
                                        </div>
                                        <div class="d-flex flex-column mt-3">
                                            <label class="mb-0">{{ $t('AppImplementForm.Distância do conector') }}</label>
                                            <InputNumber v-model.number="formMeasurements.crp[0]" suffix=" cm"
                                                         :useGrouping="false" :min="0"
                                                         placeholder="Digite o valor em centímetros"
                                                         :class="{'p-invalid': fieldNotFilled(formMeasurements.crp[0])}"/>
                                            <small v-if="fieldNotFilled(formMeasurements.crp[0])" class="pl-1 pt-1"
                                                   style="color: #f44336">
                                                {{ $t('AppImplementForm.Campo obrigatório') }}
                                            </small>
                                            <small class="text-right mt-1" style="height: 1rem">
                                                {{ showValueInMeters(formMeasurements.crp[0]) }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group mx-2 mt-2 mt-md-5 row justify-content-between px-0">
                                    <div class="col-12 col-md-4 text-center">
                                        <div>
                                            {{ $t('AppImplementForm.Ponto de Trabalho') }}
                                            <i class="pi pi-question-circle"
                                               v-tooltip.top="'Distância em linha do ponto de conexão ao ponto onde ocorre a operação'"></i>
                                        </div>
                                        <img class="image" src="@/assets/images/implement/implement-erp_x.png">
                                    </div>
                                    <div class="col-12 col-md-7 d-flex flex-column text-left">
                                        <label class="mb-0">Distância do ponto de trabalho</label>
                                        <InputNumber v-model.number="formMeasurements.function[0].erp[0]" suffix=" cm"
                                                     placeholder="Digite o valor em centímetros" :min="0"
                                                     :useGrouping="false"
                                                     :class="{'p-invalid': fieldNotFilled(formMeasurements.function[0].erp[0])}"/>
                                        <small v-if="fieldNotFilled(formMeasurements.function[0].erp[0])"
                                               class="pl-1 pt-1" style="color: #f44336">
                                            {{ $t('AppImplementForm.Campo obrigatório') }}
                                        </small>
                                        <small class="text-right mt-1" style="height: 1rem">
                                            {{ showValueInMeters(formMeasurements.function[0].erp[0]) }}
                                        </small>
                                    </div>
                                </div>

                                <div class="form-group mx-2 mt-2 mt-md-5 row justify-content-between px-0">
                                    <div class="col-12 col-md-4 text-center">
                                        <div>
                                            {{ $t('AppImplementForm.Largura de Trabalho') }}
                                            <i class="pi pi-question-circle"
                                               v-tooltip.top="'Informe a largura total do trabalho'"></i>
                                        </div>
                                        <img class="image" src="@/assets/images/implement/implement-width.png">
                                    </div>
                                    <div class="col-12 col-md-7 d-flex flex-column text-left">
                                        <label class="mb-0">Largura</label>
                                        <InputNumber v-model.number="formMeasurements.function[0].width"
                                                     suffix=" cm" :min="0" :useGrouping="false"
                                                     placeholder="Digite o valor em centímetros"
                                                     :class="{'p-invalid': fieldNotFilled(formMeasurements.function[0].width)}"/>
                                        <small v-if="fieldNotFilled(formMeasurements.function[0].width)"
                                               class="pl-1 pt-1" style="color: #f44336">
                                            {{ $t('AppImplementForm.Campo obrigatório') }}
                                        </small>
                                        <small class="text-right mt-1" style="height: 1rem">
                                            {{ showValueInMeters(formMeasurements.function[0].width) }}
                                        </small>
                                    </div>
                                </div>

                                <div class="form-group mx-2 mt-2 mt-md-5 row justify-content-between px-0">
                                    <div class="col-12 col-md-4 text-center">
                                        <div>
                                            {{ $t('AppImplementForm.Quantidade de seções') }}
                                            <i class="pi pi-question-circle"
                                               v-tooltip.top="'Informe a quantidade de seções do implemento'"></i>
                                        </div>
                                        <img class="image" src="@/assets/images/implement/implement-sections.png">
                                    </div>
                                    <div class="col-12 col-md-7 d-flex flex-column text-left">
                                        <label class="mb-0">{{ $t('AppImplementForm.Seções') }}</label>
                                        <InputNumber
                                            v-model.number="formMeasurements.function[0].number_of_sections"
                                            :min="0" suffix=" seções" :useGrouping="false"
                                            placeholder="Digite o número de seções"
                                            :class="{'p-invalid': fieldNotFilled(formMeasurements.function[0].number_of_sections)}"/>
                                        <small
                                            v-if="fieldNotFilled(formMeasurements.function[0].number_of_sections)"
                                            class="pl-1 pt-1" style="color: #f44336">
                                            {{ $t('AppImplementForm.Campo obrigatório') }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="dashed row mt-1"/>
                        <div class="form-group">
                            <label> {{ $t('AppImplementForm.Selecione o beacon') }}</label>
                            <Dropdown v-model="formBeacon" :options="beacons" :optionDisabled="isBeaconDisabled"
                                      optionLabel="mac_address"
                                      :filter="true" :filterPlaceholder="$t('AppOperatorsForm.Procurar')"
                                      :showClear="true" style="width: 100%;">

                            </Dropdown>
                        </div>
                        <div class="mt-3 d-flex flex-row-reverse">
                            <Button class="p-button-info ml-3" :label="$t('AppImplementForm.Salvar')" @click="save"/>
                        </div>
                    </div>
                </form>
            </div>

            <Dialog :visible.sync="showSaveDialog" modal>
                <template #header>
                    <div style="font-size: larger; font-weight: bold; width: 25vw" class="pl-3">
                        {{ $t('AppImplementForm.Atenção!') }}
                    </div>
                </template>
                <ProgressSpinner v-if="loadingSave" style="height: 40px"
                                 class="mt-4 mb-4 d-flex align-items-center justify-content-center"/>
                <div v-else class="d-flex flex-column align-items-center dialog-size" style="font-size: 1.2rem">
                    {{ $t('AppImplementForm.Você confirma a') }} {{ isEditing ? $t('AppImplementForm.edição') : $t('AppImplementForm.criação') }} {{ $t('AppImplementForm.deste implemento?') }}
                </div>
                <template #footer>
                    <Button :disabled="loadingSave" :label="$t('AppImplementForm.Cancelar')" @click="closeDialog" class="p-button-secondary"/>
                    <Button :disabled="loadingSave" :label="$t('AppImplementForm.Confirmar')" @click="confirmSave" class="p-button-info"/>
                </template>
            </Dialog>
        </div>
    </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import AppButton from "@/components/common/AppButton";
import {router} from "@/router";
import OrganizationsService from "@/services/OrganizationsService";
import ImplementsService from "@/services/ImplementsService";
import BeaconsService from "@/services/BeaconsService";
import Button from "primevue/button";
import {
    CONNECTOR_TYPES,
    CULTURE_PRACTICE_LIST,
    IMPLEMENT_POSITIONS,
    IMPLEMENTS_TYPES, MONITORING_SYSTEMS
} from "@/constants/ImplementConstants";
import InputNumber from "primevue/inputnumber";
import SelectButton from "primevue/selectbutton";
import Tooltip from "primevue/tooltip";
import Dialog from "primevue/dialog";
import ProgressSpinner from "primevue/progressspinner";
import Checkbox from "primevue/checkbox";

export default {
    beforeMount() {
        if (!this.$route.query.org_id) {
            this.showErrorToast(this.$t('AppImplementForm.Houve um erro ao carregar a página'))
            this.back()
        }

        this.organizationId = this.$route.query.org_id
        if (this.$route.query.implement_id) {
            this.implementId = this.$route.query.implement_id
            this.isEditing = true
        }
    },
    mounted() {
        this.organizationsService = new OrganizationsService();
        this.implementsService = new ImplementsService();
        this.beaconsService = new BeaconsService();
        this.getOrganizations()
    },
    data() {
        return {
            organizationsService: null,
            implementsService: null,
            implementTypes: IMPLEMENTS_TYPES.slice(1),
            connectorTypes: CONNECTOR_TYPES.slice(1),
            culturePracticeList: CULTURE_PRACTICE_LIST.slice(1),
            monitoringSystemList: MONITORING_SYSTEMS,
            implementPositions: IMPLEMENT_POSITIONS,
            loading: true,
            loadingMeasurements: false,
            loadingSave: false,
            isEditing: false,
            organizationId: null,
            organizationName: null,
            implementId: null,
            selectedImplement: null,
            isPlatform: false,
            implementManufacturers: [],
            implementModels: [],
            formImplementIdentification: null,
            formImplementChassis: null,
            formImplementManufacturer: null,
            formOtherManufacturer: null,
            formImplementModel: null,
            formOtherModel: null,
            formImplementType: null,
            formConnectorTypeSelected: null,
            formCulturePracticeSelected: null,
            formMonitoringSystem: null,
            hasMonitoringSystem: false,
            formMeasurements: {
                implement_position: {},
                crp: [null, 0, 0, null],
                function: [{
                    erp: [null, 0, 0],
                    description: null,
                    culture_practice: null,
                    number_of_sections: null,
                    width: null
                }]
            },
            otherModel: false,
            nameInUse: false,
            chassisInUse: false,
            submitted: false,
            measurementsSubmitted: false,
            showSaveDialog: false,
            beacons: [],
            originalBeacon: null,
            formBeacon: null,
            beaconsService: null
        }
    },
    methods: {
        isBeaconDisabled(beacon) {
            return beacon.disabled
        },
        getOrganizations() {
            this.loading = true
            this.organizationsService.getAllV3('ORGANIZATION_IMPLEMENTS')
                .then(response => {
                    this.findOrgName(response);
                    if (this.isEditing) {
                        this.getOrganizationImplementInfo(this.implementId)
                        return
                    }

                    this.getImplementManufacturers();
                    this.getBeacons()
                }).catch(() => {
                this.showErrorToast(this.$t('AppImplementForm.Não foi possível buscar as organizações'))
                this.back()
            })
        },
        findOrgName(organizations) {
            let foundOrg = organizations.find(org => org.id === this.organizationId)

            if (foundOrg === undefined) {
                this.showErrorToast(this.$t('AppImplementForm.Não foi possível encontrar a organização'))
                this.back()
                return
            }

            this.organizationName = foundOrg.name
        },
        getImplementManufacturers() {
            this.implementsService.getImplementManufacturers()
                .then(response => {
                    this.implementManufacturers = response.sort((a, b) => a.name.localeCompare(b.name))
                    if (this.isEditing) {
                        this.setImplementManufacturer()
                        return
                    }
                    this.loading = false
                })
                .catch(() => {
                    this.showErrorToast(this.$t('AppImplementForm.Não foi possível recuperar a lista de fabricantes de implemento'))
                    this.loading = false
                })
        },
        setImplementManufacturer() {
            if (this.selectedImplement.is_other) {
                this.otherModel = true
                this.formOtherManufacturer = this.selectedImplement.manufacturer_name
                this.formOtherModel = this.selectedImplement.model_name
                this.formImplementType = this.parseImplementType(this.selectedImplement.implement_type)
                this.loading = false
                return;
            }

            let foundManufacturer = this.implementManufacturers.find(manufacturer => manufacturer.id === this.selectedImplement.manufacturer_id)

            if (foundManufacturer === undefined) {
                this.showErrorToast(this.$t('AppImplementForm.Não foi possível encontrar o fabricante do implemento'))
                this.loading = false
                return
            }

            this.formImplementManufacturer = foundManufacturer
            this.getImplementModels(true)
        },
        getImplementModels(setModel) {
            this.implementModels = []
            this.measurementsSubmitted = false
            this.formImplementModel = null
            if (!setModel) {
                this.selectedImplement = null
            }
            this.implementsService.findAllModelsByManufacturerId(this.formImplementManufacturer.id)
                .then(response => {
                    this.implementModels = response.sort((a, b) => a.name.localeCompare(b.name))
                    if (setModel) {
                        this.setImplementModel()
                    }
                })
                .catch(() => {
                    this.showErrorToast(this.$t('AppImplementForm.Não foi possível recuperar a lista de modelos deste fabricante'))
                    this.loading = false
                })
        },
        setImplementModel() {
            let foundModel = this.implementModels.find(model => model.id === this.selectedImplement.model_id)

            if (foundModel === undefined) {
                this.showErrorToast(this.$t('AppImplementForm.Não foi possível encontrar o modelo deste implemento'))
                this.loading = false
                return
            }

            this.formImplementModel = foundModel
            this.formImplementType = this.parseImplementType(this.formImplementModel.implement_type)
            this.loading = false
        },
        getOrganizationImplementInfo(id) {
            this.loadingMeasurements = true
            this.measurementsSubmitted = false
            this.implementsService.getOrganizationImplement(id)
                .then(response => {
                    this.selectedImplement = response
                    this.parseImplement(true)
                    this.getImplementManufacturers()
                    this.getBeacons()
                })
                .catch(() => {
                    this.showErrorToast(this.$t('AppImplementForm.Não foi possível recuperar os dados do implemento'))
                    this.loadingMeasurements = false
                })
        },
        getBeacons() {
            let beacon_info = [];
            this.beaconsService.getAllBeaconsByOrgId(this.organizationId).then((results) => {
                let beaconsFound = results.filter((beacon) => beacon.type === 'IMPLEMENT');

                this.beaconsService.getBeaconsLinksByOrgId(this.organizationId).then((linksResponse) => {

                    beaconsFound.forEach(element => {
                        let link = linksResponse.find(link => link.mac_address === element.mac_address);

                        let newBeacon = {
                            "mac_address": element.mac_address,
                            "beacon_id": element.id,
                            "disabled": link != null,
                            "link": link
                        }

                        beacon_info.push(newBeacon)

                        if (link != null && link.linked_entity_id === this.implementId) {
                            this.originalBeacon = newBeacon
                            this.formBeacon = newBeacon
                        }
                    });

                    this.beacons = beacon_info;
                })
            })
                .catch((error) => {
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppImplementForm.Não foi possivel completar a operação'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppImplementForm.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                    console.log(error)
                    this.back()
                }).finally(() => {
            })
        },
        getImplementInfo() {
            this.otherModel = false
            this.loadingMeasurements = true
            this.measurementsSubmitted = false
            this.formImplementType = this.parseImplementType(this.formImplementModel.implement_type)
            this.implementsService.getImplement(this.formImplementModel.id)
                .then(response => {
                    this.selectedImplement = response
                    this.parseImplement(false)
                })
                .catch(() => {
                    this.showErrorToast(this.$t('AppImplementForm.Não foi possível recuperar os dados do implemento'))
                    this.loadingMeasurements = false
                })
        },
        parseImplement(isOrgImplement) {
            if (isOrgImplement) {
                this.formImplementIdentification = this.selectedImplement.identification
                this.formImplementChassis = this.selectedImplement.chassis
            }

            this.isPlatform = this.selectedImplement.implement_type === 25
            if (this.selectedImplement.descriptor) {
                this.parseMeasurements(JSON.parse(this.selectedImplement.descriptor))
                this.setCulturePractice()
                this.setConnectorType()
                this.loadingMeasurements = false
                return
            }

            this.clearMeasurements();
            this.loadingMeasurements = false
        },
        clearMeasurements() {
            this.formConnectorTypeSelected = null
            this.formCulturePracticeSelected = null
            this.hasMonitoringSystem = false
            this.formMeasurements = {
                implement_position: this.implementPositions[1],
                crp: [null, 0, 0, null],
                function: [{
                    erp: [null, 0, 0],
                    description: null,
                    culture_practice: null,
                    number_of_sections: null,
                    width: null
                }]
            }

            if (this.isPlatform) {
                this.setConnectorType();
            }
        },
        parseMeasurements(modelMeasurements) {
            this.formMeasurements.function = []

            if ('CRP' in modelMeasurements) {
                this.formMeasurements.crp[0] = Math.trunc(Math.abs(modelMeasurements.CRP[0][0]) / 10)
                this.formMeasurements.crp[3] = modelMeasurements.CRP[0][3]
                this.formMeasurements.implement_position = this.parseImplementPosition(modelMeasurements.CRP[0][0])
            }

            modelMeasurements['Function'].forEach(implementFunction => {
                let parsedFunction = {
                    erp: [null, 0, 0],
                    description: null,
                    culture_practice: null,
                    number_of_sections: null,
                    width: null
                }

                if ('ERP' in implementFunction) {
                    parsedFunction.erp[0] = Math.trunc(Math.abs(implementFunction.ERP[0] / 10))
                }

                if ('Description' in implementFunction) {
                    parsedFunction.description = implementFunction.Description
                }

                if ('Culture_practice' in implementFunction) {
                    parsedFunction.culture_practice = implementFunction.Culture_practice
                }

                if ('Number_of_sections' in implementFunction) {
                    parsedFunction.number_of_sections = implementFunction.Number_of_sections
                }

                if ('Width' in implementFunction) {
                    parsedFunction.width = Math.trunc(implementFunction.Width / 10)
                }

                this.formMeasurements.function.push(parsedFunction)
            })
        },
        parseImplementPosition(crpX) {
            if (crpX > 0) {
                return this.implementPositions[1]
            }

            return this.implementPositions[0]
        },
        handleCulturePractice() {
            if (this.formCulturePracticeSelected.value === 2) {
                this.hasMonitoringSystem = true
                return
            }

            this.hasMonitoringSystem = false
            this.formMonitoringSystem = null
        },
        setCulturePractice() {
            let culturePracticeFound = this.culturePracticeList.find(culture => culture.value === this.formMeasurements.function[0].culture_practice)

            if (!culturePracticeFound) {
                this.formCulturePracticeSelected = this.culturePracticeList[0]
                return
            }

            this.formCulturePracticeSelected = culturePracticeFound
            if (this.formCulturePracticeSelected.value === 2) {
                this.hasMonitoringSystem = true
                this.setMonitoringSystem()
            }
        },
        setMonitoringSystem() {
            if (this.selectedImplement.monitoring_system === null) {
                return
            }

            let foundMonitoringSystem = this.monitoringSystemList.find(system => system.value === this.selectedImplement.monitoring_system)

            if (!foundMonitoringSystem) {
                return
            }

            this.formMonitoringSystem = foundMonitoringSystem
        },
        setConnectorType() {
            if (this.isPlatform) {
                this.formConnectorTypeSelected = this.connectorTypes.find(connector => connector.id === 3)
                return
            }

            let connectorTypeFound = this.connectorTypes.find(connector => connector.id === this.formMeasurements.crp[3])

            if (!connectorTypeFound) {
                this.formConnectorTypeSelected = this.connectorTypes[0]
                return
            }

            this.formConnectorTypeSelected = connectorTypeFound
        },
        handleImplementType() {
            this.isPlatform = this.formImplementType.value === 25
            this.clearMeasurements()
        },
        parseImplementType(vehicleTypeCode) {
            return this.implementTypes.find(type => type.value === vehicleTypeCode);
        },
        validateIdentification(event) {
            this.nameInUse = false
            this.formImplementIdentification = event.replace(/[^a-z0-9 ]/gi, '')
        },
        clearOtherModelInputs() {
            this.formOtherManufacturer = null
            this.formOtherModel = null
            this.selectedImplement = null
            this.clearMeasurements()
        },
        clearModelInputs() {
            if (this.formImplementManufacturer) {
                this.formOtherManufacturer = this.formImplementManufacturer.name
            }
            this.formImplementManufacturer = null
            this.formImplementModel = null
            this.selectedImplement = {}
            this.clearMeasurements()
        },
        showValueInMeters(value) {
            if (value === null) {
                return ''
            }

            if (value % 1 !== 0) {
                return
            }
            const METER_CONVERSION = value / 100
            const METER_TEXT = METER_CONVERSION <= 1 ? this.$t('AppImplementForm.metro') : this.$t('AppImplementForm.metros')
            return this.$t('AppImplementForm.O valor é de ') + METER_CONVERSION + METER_TEXT
        },
        save() {
            this.submitted = true
            this.measurementsSubmitted = true
            if (this.isValidForm()) {
                this.showSaveDialog = true
            }
        },
        confirmSave() {
            this.loadingSave = true
            if (this.isEditing) {
                this.updateImplement(this.buildImplement())
                return
            }

            this.saveImplement(this.buildImplement())
        },
        isValidForm() {
            if (!this.formImplementIdentification) {
                this.scrollUp(0)
                return false
            }

            if (!this.validModelInput()) {
                return false
            }

            if (!this.formConnectorTypeSelected) {
                this.scrollUp(500)
                return false
            }

            if (!this.formCulturePracticeSelected) {
                this.scrollUp(500)
                return false
            }

            if (this.formCulturePracticeSelected.value === 2) {
                if (this.formMonitoringSystem === null) {
                    this.scrollUp(500)
                    return false
                }
            }

            if (this.formMeasurements.function[0].erp[0] === null) {
                this.scrollUp(900)
                return false
            }

            if (this.formMeasurements.function[0].width === null) {
                this.scrollUp(900)
                return false
            }

            if (!this.isPlatform) {
                if (this.formMeasurements.crp[0] === null) {
                    this.scrollUp(900)
                    return false
                }

                if (this.formMeasurements.function[0].number_of_sections === null) {
                    this.scrollUp(900)
                    return false
                }
            }

            return true
        },
        validModelInput() {
            if (this.otherModel) {
                if (!this.formOtherManufacturer || !this.formOtherModel || !this.formImplementType) {
                    this.scrollUp(250)
                    return false
                }

                return true
            }

            if (!this.formImplementManufacturer || !this.formImplementModel) {
                return false
            }

            return true
        },
        fieldNotFilled(field) {
            if (!this.measurementsSubmitted) {
                return false
            }

            return field === null
        },
        updateImplement(formattedImplement) {
            this.implementsService.updateImplement(this.organizationId, this.implementId, formattedImplement)
                .then(() => {
                    this.handleUpdateLink(this.implementId)
                })
                .catch(error => {
                    if (error.response && error.response.status === 409 && error.response.data.details.includes("chassis")) {
                        this.showErrorToast(this.$t('AppImplementForm.Este chassis já está sendo utilizado por outro implemento'))
                        this.chassisInUse = true
                        this.loadingSave = false
                        this.scrollUp(0)
                        this.closeDialog()
                        return;
                    } else if (error.response && error.response.status === 409) {
                        this.showErrorToast(this.$t('AppImplementForm.Este nome já está sendo utilizado por outro implemento'))
                        this.nameInUse = true
                        this.loadingSave = false
                        this.scrollUp()
                        this.closeDialog()
                        return;
                    } else if (error.response && error.response.status === 400) {
                        this.showErrorToast(this.$t('AppImplementForm.Implemento está vinculado ao veículo, desvincule antes de editá-lo'))
                        this.back()
                        return;
                    } else if (error.response && error.response.status === 403) {
                        this.showErrorToast(this.$t('AppImplementForm.Este implemento está realizando um trabalho, não pode ser editado'))
                        this.back()
                        return;
                    }

                    this.showErrorToast(this.$t('AppImplementForm.Não foi possível atualizar os dados do implemento'))
                    this.loadingSave = false
                })
        },
        saveImplement(formattedImplement) {
            this.implementsService.saveImplement(this.organizationId, formattedImplement)
                .then((result) => {
                    this.handleLinkCreation(result)
                })
                .catch(error => {
                    if (error.response && error.response.status === 409 && error.response.data.details.includes("chassis")) {
                        this.showErrorToast(this.$t('AppImplementForm.Este chassis já está sendo utilizado por outro implemento'))
                        this.chassisInUse = true
                        this.loadingSave = false
                        this.scrollUp(0)
                        this.closeDialog()
                        return;
                    } else if (error.response && error.response.status === 409) {
                        this.showErrorToast(this.$t('AppImplementForm.Este nome já está sendo utilizado por outro implemento'))
                        this.nameInUse = true
                        this.loadingSave = false
                        this.scrollUp(0)
                        this.closeDialog()
                        return;
                    }

                    this.showErrorToast(this.$t('AppImplementForm.Não foi possível cadastrar o implemento'))
                    this.loadingSave = false
                })
        },
        shouldSaveNewLink() {
            if (!this.formBeacon) {
                return false;
            }

            if (!this.originalBeacon) {
                return true;
            }

            return this.originalBeacon.beacon_id !== this.formBeacon.beacon_id;
        },
        handleLinkCreation(implementId) {
            if (!this.shouldSaveNewLink()) {
                this.showSuccessToast(this.$t('AppImplementForm.Operação realizada com sucesso'))
                this.back()
                return;
            }

            this.beaconsService.createImplementBeaconLink({
                "implement_id": implementId,
                "beacon_id": this.formBeacon.beacon_id
            }).then((result) => {
                this.showSuccessToast(this.$t('AppImplementForm.Operação realizada com sucesso'))
                this.back()
            })
        },
        shouldRemoveLink() {
            if (!this.originalBeacon) {
                return false;
            }

            if (!this.formBeacon) {
                return true;
            }

            return this.originalBeacon.beacon_id != this.formBeacon.beacon_id;
        },
        handleUpdateLink(implementId) {
            if (this.shouldRemoveLink()) {
                this.beaconsService.deleteImplementBeaconLink(this.originalBeacon.link.id).then(() => {
                    this.handleLinkCreation(implementId);
                })
                return;
            }

            this.handleLinkCreation(implementId);
        },
        buildImplement() {
            let implement = {}
            implement.identification = this.formImplementIdentification
            implement.chassis = this.formImplementChassis
            implement.implementModelId = this.otherModel ? null : this.formImplementModel.id
            implement.otherManufacturer = this.formOtherManufacturer
            implement.otherModel = this.formOtherModel
            implement.otherType = this.otherModel ? this.formImplementType.value : null
            implement.monitoringSystem = this.formMonitoringSystem ? this.formMonitoringSystem.value : null

            let formattedMeasurements = JSON.parse(JSON.stringify(this.formMeasurements))
            formattedMeasurements.crp[0] = formattedMeasurements.crp[0] * this.formMeasurements.implement_position.crpMultiplier
            formattedMeasurements.crp[3] = this.formConnectorTypeSelected.id
            formattedMeasurements.function[0].erp[0] = formattedMeasurements.function[0].erp[0] * this.formMeasurements.implement_position.erpMultiplier
            formattedMeasurements.function[0].width = formattedMeasurements.function[0].width * 10
            formattedMeasurements.function[0].culture_practice = this.formCulturePracticeSelected.value
            delete formattedMeasurements.function[0].description

            if (this.isPlatform) {
                formattedMeasurements.function[0].number_of_sections = 1
            }

            implement.measurements = formattedMeasurements

            return implement
        },
        closeDialog() {
            this.showSaveDialog = false
        },
        back() {
            router.go(-1)
        },
        scrollUp(pos) {
            scrollTo(0, pos)
        },
        showSuccessToast(message) {
            this.$toast.add({
                severity: 'success',
                summary: this.$t('AppImplementForm.Sucesso'),
                detail: message,
                life: 3000
            });
        },
        showErrorToast(message) {
            this.$toast.add({
                severity: 'error',
                summary: this.$t('AppImplementForm.Erro'),
                detail: message,
                life: 3000
            });
        },
        handleCheckbox() {
            this.submitted = false
            this.measurementsSubmitted = false
            this.formImplementType = null
            if (this.otherModel) {
                this.clearOtherModelInputs()
                return;
            }
            this.clearModelInputs()
        }
    },
    directives: {
        tooltip: Tooltip
    },
    components: {
        AppButton, Dropdown, InputText, Button, InputNumber, SelectButton, Dialog, ProgressSpinner, Checkbox
    }
}
</script>

<style scoped>
.image {
    max-width: 12vw;
}

.kt-form {
    width: 45%;
    margin: 0 auto;
}

.dialog-size {
    width: 25vw;
}

@media (max-width: 758px) {
    .image {
        max-width: 50vw;
    }

    .kt-form {
        width: 95%;
    }

    .dialog-size {
        width: 60vw;
    }
}

@media (max-width: 1024px) and (min-width: 758px) {
    .image {
        max-width: 20vw;
    }

    .kt-form {
        width: 80%;
    }

    .dialog-size {
        width: 50vw;
    }
}

.loading {
    height: 15vh;
}

hr.dashed {
    border-top: 1px dashed #bbb;
}
</style>
